import navDataIcon from 'assets/nav_data_icon.png';

interface Properties {
  width?: number;
  height?: number;
}

const ImportDataIconActive = ({ width = 16, height = 16 }: Properties) => {
  return (
    <img
      src={navDataIcon}
      alt=''
      width={width}
      height={height}
      style={{ filter: 'brightness(0) invert(1)' }}
    />
  );
};

export default ImportDataIconActive;
